import React from 'react';
import classnames from 'classnames';

const ThumbnailImageCentered = ({ alt, src, className, rounded, small }) => {
  return (
    <div className="thumbnail-centered">
    <img
      alt={alt}
      src={src}
      className={` ${"portrait " +classnames(
        {
          'rounded-circle': rounded,
          small,

        }
      )}`}
    />
    </div>
  );
};

export default React.memo(ThumbnailImageCentered);
